import 'babel-polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import http from './utils/http'
import Es6Promise from 'es6-promise'
import { Uploader, Image as VanImage, Lazyload } from 'vant'
import 'vant/lib/uploader/style'
import VueI18n from 'vue-i18n'

Vue.use(Uploader)
Vue.use(VanImage)
Vue.use(Lazyload)
Vue.use(VueI18n)
const i18n = new VueI18n({
  // locale: navigator.language || 'zh-CN',
  messages: {
    'zh-CN': require('./common/lang/zh'),
    'en-US': require('./common/lang/en')
  }
})

require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.prototype.$http = http
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_TEST !== 'true') {
  if (window) {
    window.console.log = function () {}
  }
}

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
